import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
    const location = useLocation();
    const user = JSON.parse(localStorage.getItem('user'));

    // If not logged in, redirect to login
    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // If no specific roles are required, allow access
    if (allowedRoles.length === 0) {
        return children;
    }

    // For Companies and Zones pages, allow viewing but restrict actions
    if (location.pathname === '/companies' || location.pathname === '/zones') {
        return children;
    }

    // For other protected routes, check if user's role is in the allowed roles
    if (!allowedRoles.includes(user.role)) {
        return <Navigate to="/dashboard" replace />;
    }

    return children;
};

export default ProtectedRoute; 